/**
 * Language mappings and utilities
 */

// Language flag mapping
export const LANGUAGE_FLAGS: Record<string, string> = {
  'en': '🇺🇸',
  'en-US': '🇺🇸',
  'en-GB': '🇬🇧',
  'fr': '🇫🇷',
  'fr-FR': '🇫🇷',
  'de': '🇩🇪',
  'de-DE': '🇩🇪',
  'es': '🇪🇸',
  'es-ES': '🇪🇸',
  'it': '🇮🇹',
  'it-IT': '🇮🇹',
  'pt': '🇵🇹',
  'pt-PT': '🇵🇹',
  'pt-BR': '🇧🇷',
  'ru': '🇷🇺',
  'ru-RU': '🇷🇺',
  'ja': '🇯🇵',
  'ja-JP': '🇯🇵',
  'ko': '🇰🇷',
  'ko-KR': '🇰🇷',
  'zh': '🇨🇳',
  'zh-CN': '🇨🇳',
  'zh-TW': '🇹🇼',
  'nl': '🇳🇱',
  'nl-NL': '🇳🇱',
  'sv': '🇸🇪',
  'sv-SE': '🇸🇪',
  'da': '🇩🇰',
  'da-DK': '🇩🇰',
  'no': '🇳🇴',
  'no-NO': '🇳🇴',
  'fi': '🇫🇮',
  'fi-FI': '🇫🇮',
  'pl': '🇵🇱',
  'pl-PL': '🇵🇱',
  'cs': '🇨🇿',
  'cs-CZ': '🇨🇿',
  'sk': '🇸🇰',
  'sk-SK': '🇸🇰',
  'hu': '🇭🇺',
  'hu-HU': '🇭🇺',
  'ro': '🇷🇴',
  'ro-RO': '🇷🇴',
  'bg': '🇧🇬',
  'bg-BG': '🇧🇬',
  'hr': '🇭🇷',
  'hr-HR': '🇭🇷',
  'sl': '🇸🇮',
  'sl-SI': '🇸🇮',
  'et': '🇪🇪',
  'et-EE': '🇪🇪',
  'lv': '🇱🇻',
  'lv-LV': '🇱🇻',
  'lt': '🇱🇹',
  'lt-LT': '🇱🇹',
  'tr': '🇹🇷',
  'tr-TR': '🇹🇷',
  'ar': '🇸🇦',
  'ar-SA': '🇸🇦',
  'he': '🇮🇱',
  'he-IL': '🇮🇱',
  'th': '🇹🇭',
  'th-TH': '🇹🇭',
  'vi': '🇻🇳',
  'vi-VN': '🇻🇳',
  'id': '🇮🇩',
  'id-ID': '🇮🇩',
  'ms': '🇲🇾',
  'ms-MY': '🇲🇾',
  'hi': '🇮🇳',
  'hi-IN': '🇮🇳',
  'bn': '🇧🇩',
  'bn-BD': '🇧🇩',
  'ur': '🇵🇰',
  'ur-PK': '🇵🇰',
  'fa': '🇮🇷',
  'fa-IR': '🇮🇷',
  'uk': '🇺🇦',
  'uk-UA': '🇺🇦',
  'be': '🇧🇾',
  'be-BY': '🇧🇾',
  'kk': '🇰🇿',
  'kk-KZ': '🇰🇿',
  'uz': '🇺🇿',
  'uz-UZ': '🇺🇿',
  'ky': '🇰🇬',
  'ky-KG': '🇰🇬',
  'tg': '🇹🇯',
  'tg-TJ': '🇹🇯',
  'mn': '🇲🇳',
  'mn-MN': '🇲🇳',
  'ka': '🇬🇪',
  'ka-GE': '🇬🇪',
  'hy': '🇦🇲',
  'hy-AM': '🇦🇲',
  'az': '🇦🇿',
  'az-AZ': '🇦🇿',
  'mk': '🇲🇰',
  'mk-MK': '🇲🇰',
  'sq': '🇦🇱',
  'sq-AL': '🇦🇱',
  'mt': '🇲🇹',
  'mt-MT': '🇲🇹',
  'is': '🇮🇸',
  'is-IS': '🇮🇸',
  'ga': '🇮🇪',
  'ga-IE': '🇮🇪',
  'cy': '🇬🇧',
  'cy-GB': '🇬🇧',
  'eu': '🇪🇸',
  'eu-ES': '🇪🇸',
  'ca': '🇪🇸',
  'ca-ES': '🇪🇸',
  'gl': '🇪🇸',
  'gl-ES': '🇪🇸',
  'af': '🇿🇦',
  'af-ZA': '🇿🇦',
  'zu': '🇿🇦',
  'zu-ZA': '🇿🇦',
  'xh': '🇿🇦',
  'xh-ZA': '🇿🇦',
  'sw': '🇹🇿',
  'sw-TZ': '🇹🇿',
  'am': '🇪🇹',
  'am-ET': '🇪🇹',
  'ha': '🇳🇬',
  'ha-NG': '🇳🇬',
  'yo': '🇳🇬',
  'yo-NG': '🇳🇬',
  'ig': '🇳🇬',
  'ig-NG': '🇳🇬',
  'rw': '🇷🇼',
  'rw-RW': '🇷🇼',
  'lg': '🇺🇬',
  'lg-UG': '🇺🇬',
  'ak': '🇬🇭',
  'ak-GH': '🇬🇭',
  'tw': '🇬🇭',
  'tw-GH': '🇬🇭',
  'ff': '🇸🇳',
  'ff-SN': '🇸🇳',
  'wo': '🇸🇳',
  'wo-SN': '🇸🇳',
  'dy': '🇲🇱',
  'dy-ML': '🇲🇱',
  'bm': '🇲🇱',
  'bm-ML': '🇲🇱',
  'so': '🇸🇴',
  'so-SO': '🇸🇴',
  'om': '🇪🇹',
  'om-ET': '🇪🇹',
  'ti': '🇪🇹',
  'ti-ET': '🇪🇹',
  'sn': '🇿🇼',
  'sn-ZW': '🇿🇼',
  'st': '🇿🇦',
  'st-ZA': '🇿🇦',
  'tn': '🇧🇼',
  'tn-BW': '🇧🇼',
  'ts': '🇿🇦',
  'ts-ZA': '🇿🇦',
  've': '🇿🇦',
  've-ZA': '🇿🇦',
  'nr': '🇿🇦',
  'nr-ZA': '🇿🇦',
  'ss': '🇿🇦',
  'ss-ZA': '🇿🇦',
  'nd': '🇿🇼',
  'nd-ZW': '🇿🇼',
  'ny': '🇲🇼',
  'ny-MW': '🇲🇼',
  'mg': '🇲🇬',
  'mg-MG': '🇲🇬',
  'km': '🇰🇭',
  'km-KH': '🇰🇭',
  'lo': '🇱🇦',
  'lo-LA': '🇱🇦',
  'my': '🇲🇲',
  'my-MM': '🇲🇲',
};

const LANGUAGE_NAMES: Record<string, string> = {
  'en': 'English',
  'es': 'Spanish',
  'fr': 'French',
  'de': 'German',
  'it': 'Italian',
  'pt': 'Portuguese',
  'ru': 'Russian',
  'ja': 'Japanese',
  'ko': 'Korean',
  'zh': 'Chinese',
  'ar': 'Arabic',
  'hi': 'Hindi',
  'nl': 'Dutch',
  'sv': 'Swedish',
  'no': 'Norwegian',
  'da': 'Danish',
  'fi': 'Finnish',
  'pl': 'Polish',
  'tr': 'Turkish',
  'he': 'Hebrew',
  'th': 'Thai',
  'vi': 'Vietnamese',
  'id': 'Indonesian',
  'ms': 'Malay',
  'tl': 'Filipino',
  'el': 'Greek',
  'hu': 'Hungarian',
  'cs': 'Czech',
  'sk': 'Slovak',
  'ro': 'Romanian',
  'bg': 'Bulgarian',
  'hr': 'Croatian',
  'sl': 'Slovenian',
  'et': 'Estonian',
  'lv': 'Latvian',
  'lt': 'Lithuanian',
  'mt': 'Maltese',
  'ga': 'Irish',
  'cy': 'Welsh',
  'is': 'Icelandic',
  'fo': 'Faroese',
  'sq': 'Albanian',
  'mk': 'Macedonian',
  'sr': 'Serbian',
  'bs': 'Bosnian',
  'me': 'Montenegrin',
  'uk': 'Ukrainian',
  'be': 'Belarusian',
  'kk': 'Kazakh',
  'ky': 'Kyrgyz',
  'uz': 'Uzbek',
  'tg': 'Tajik',
  'mn': 'Mongolian',
  'ka': 'Georgian',
  'hy': 'Armenian',
  'az': 'Azerbaijani',
  'fa': 'Persian',
  'ur': 'Urdu',
  'bn': 'Bengali',
  'ta': 'Tamil',
  'te': 'Telugu',
  'kn': 'Kannada',
  'ml': 'Malayalam',
  'gu': 'Gujarati',
  'pa': 'Punjabi',
  'or': 'Odia',
  'as': 'Assamese',
  'ne': 'Nepali',
  'si': 'Sinhala',
  'my': 'Burmese',
  'km': 'Khmer',
  'lo': 'Lao',
  'am': 'Amharic',
  'sw': 'Swahili',
  'zu': 'Zulu',
  'af': 'Afrikaans',
  'xh': 'Xhosa',
  'yo': 'Yoruba',
  'ig': 'Igbo',
  'ha': 'Hausa',
  'so': 'Somali',
  'rw': 'Kinyarwanda',
  'lg': 'Luganda',
  'ak': 'Akan',
  'tw': 'Twi',
  'ee': 'Ewe',
  'fon': 'Fon',
  'dyo': 'Jola-Fonyi',
  'wo': 'Wolof',
  'ff': 'Fulah',
  'bm': 'Bambara',
  'sn': 'Shona',
  'ny': 'Chichewa',
  'st': 'Southern Sotho',
  'tn': 'Tswana',
  'ts': 'Tsonga',
  've': 'Venda',
  'nr': 'Southern Ndebele',
  'ss': 'Swati',
  'nd': 'Northern Ndebele',
  'qu': 'Quechua',
  'ay': 'Aymara',
  'gn': 'Guarani',
  'ht': 'Haitian Creole',
  'jv': 'Javanese',
  'su': 'Sundanese',
  'ceb': 'Cebuano',
  'war': 'Waray',
  'hil': 'Hiligaynon',
  'bik': 'Bikol',
  'pam': 'Kapampangan',
  'pag': 'Pangasinan',
  'ilo': 'Iloko',
  'cbk': 'Chavacano',
  'ch': 'Chamorro',
  'haw': 'Hawaiian',
  'mi': 'Maori',
  'sm': 'Samoan',
  'to': 'Tongan',
  'fj': 'Fijian',
  'ty': 'Tahitian',
  'mg': 'Malagasy'
};

/**
 * Get the language flag emoji for a language code
 */
export function getLanguageFlag(languageCode: string): string {
  return LANGUAGE_FLAGS[languageCode] || '🌐';
}

/**
 * Get the language name for a language code
 */
export function getLanguageName(languageCode: string): string {
  return LANGUAGE_NAMES[languageCode] || languageCode;
}

/**
 * Get the source text label based on the selected game's default language
 */
export function getSourceTextLabel(defaultLanguage?: string): string {
  if (defaultLanguage) {
    return getLanguageName(defaultLanguage);
  }
  return 'Source Text';
}

